const events = () => {
	document.addEventListener('DOMContentLoaded', function () {
		const flexibleEvents = document.querySelector('.flexible-events');
		if (flexibleEvents) {
			const showMoreBtn = flexibleEvents.querySelectorAll('.show-more');

			showMoreBtn.forEach((btn, i) =>
				btn.addEventListener('click', (e) => {
					let parent = e.target.parentElement.parentElement;

					parent.classList.toggle('open');

					if (parent.classList.contains('open')) {
						showMoreBtn[i].innerHTML = 'Show Less';
					} else {
						showMoreBtn[i].innerHTML = 'Show More';
					}
				})
			);
		}
	});
};

export default events;
